var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bon-store-select"},[_c('v-overflow-btn',{attrs:{"items":_vm.storeItems,"label":"Выберите кофейню","editable":"","rules":_vm.rulesStore},on:{"change":_vm.emitToParent},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }